module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch",
    on: {
      "click": _vm.toggleIsOn
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOn),
      expression: "isOn"
    }],
    attrs: {
      "type": "checkbox",
      "id": "do-switch"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOn) ? _vm._i(_vm.isOn, null) > -1 : (_vm.isOn)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isOn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isOn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOn = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "slider round",
    attrs: {
      "for": "do-switch"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7612b8c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AppToggle.vue
// module id = 2016
// module chunks = 1